import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Channels() {
  return (
    <div>
      <Paragraph size="2">
        Use <em>channels</em> to organize videos by theme or some other grouping. You can
        incorporate your own videos as well as videos from other Vimeo members on any channel that
        you create. Vimeo Free subscribers get one channel, while paid Vimeo members can have an
        unlimited number. See our{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12426200314513-Channels"
        >
          Help Center
        </Link>{' '}
        for more details.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
